import React from 'react'

export default function Footer() {
  return (
    <div className='bg-dark py-5 text-center'>
        <span className='text-white '>Movies World &copy; 8/24/2023</span>
    </div>
  )
}
